<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item
            prop="name"
          label="名称">
          <a-input placeholder="请输入名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
            prop="code"
          label="CODE">
          <a-input placeholder="请输入code" v-model="model.code" />
        </a-form-model-item>
        <a-form-model-item
            prop="min"
          label="最小值">
          <a-input placeholder="请输入最小值" v-model="model.min" />
        </a-form-model-item>
        <a-form-model-item
            prop="max"
          label="最大值">
          <a-input placeholder="请输入最大值" v-model="model.max" />
        </a-form-model-item>
        <a-form-model-item
            prop="appraise"
          label="评价">
          <a-textarea :rows="2" placeholder="请输入评价" v-model="model.appraise" />
        </a-form-model-item>
        <a-form-model-item
            prop="suggest"
          label="建议">
          <a-textarea :rows="4" placeholder="请输入建议" v-model="model.suggest" />
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import ATextarea from 'ant-design-vue/es/input/TextArea'

  export default {
    name: "ProjectResultConfigItemChildModal",
    components: { ATextarea },
    props:{
      configItemId:''
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{
          name:[baseRules.required],
          code:[baseRules.required],
          min:[baseRules.required],
          max:[baseRules.required],
          appraise:[baseRules.required],
          suggest:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/project/projectResultConfigItemChild/add",
          edit: "/project/projectResultConfigItemChild/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        if(!this.configItemId){
          return this.$message.warning('请选择一条数据进行添加')
        }
        this.edit({
          configItemId:this.configItemId
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>